import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalButtons} from 'shared/components/modals';

const PublishConfirmationModal = observer(({uiState, isOpen}) => {
  const {publishRequest, schedule} = uiState;

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => uiState.closePublishConfirmationModal()}
      size='sm'
      title={publishRequest.employee ? 'time_tracking.shifts.Publish Shifts' : 'time_tracking.shifts.Publish Schedule'}
    >
      <div className='jumbo mb2'>
        <FormattedMessage
          id='time_tracking.shifts.PUBLISH_CONFIRMATION'
          values={{count: publishRequest.count, week: uiState.weekRange}}
        />
      </div>
      {(publishRequest.employee ? schedule.sendsNotificationsTo(publishRequest.employee.id) : schedule.notifiesOnPublish) && <div className='jumbo mb2'>
        {publishRequest.employee ?
          <FormattedMessage id='time_tracking.shifts.PUBLISH_EMPLOYEE_EMAIL_NOTICE' values={{name: publishRequest.employee.name}}/> :
          <FormattedMessage id='time_tracking.shifts.PUBLISH_EMAIL_NOTICE'/>}
      </div>}
      <ModalButtons
        saveCaption='time_tracking.shifts.Publish'
        onSave={() => uiState.confirmPublish()}
        onCancel={() => uiState.closePublishConfirmationModal()}
      />
    </Modal>
  );
});

export default PublishConfirmationModal;
